export class Fines {
  constructor(http) {
    this.http = http;
  }

  fetchFines(startDate, endDate, filters = [], page = 1) {
    let params = { page, page_size: 15 };

    if (startDate && endDate) {
      params.startDate = startDate.valueOf();
      params.endDate = endDate.valueOf();
    }

    filters.forEach(filter => {
      params[filter.type] = filter.value;
    });

    return this.http.get(`fines`, { params }).then(response => response.data);
  }

  fetchFinesStatuses() {
    return this.http.get('reports/status').then(response => response.data);
  }

  fetchFinesGrouping() {
    return this.http.get('reports/sort').then(response => response.data);
  }

  fetchFinesPresets() {
    return this.http.get('reports/preset').then(response => response.data);
  }
}
